<script setup>
import {ref} from "vue";
import {axiosDownloadFile} from "@/composables/downloadFile";
import {useMutation} from "@tanstack/vue-query";
import DropdownRow from "@/components/global-themed/inputs/dropdown/DropdownRow.vue";
import BaseDropdown from "@/components/global-themed/inputs/dropdown/BaseDropdown.vue";
import SquareIconButton from "@/components/global-themed/buttons/SquareIconButton.vue";
import {errorToast} from "@/composables/useToasts";

const showDropdown = ref(false);

const {mutate: exportLiveActionsCSV} = useMutation({
  mutationFn: async () => {
    await axiosDownloadFile('/ajax/v2/actions/export/csv/live');
  },
  onSuccess: async () => {
   window.mixpanel('Actions v2: Export CSV');
  },
  onError: () => {
    errorToast('Something went wrong generating the CSV');
  }
});
</script>

<template>
  <BaseDropdown
    v-model:dropdownOpen="showDropdown"
  >
    <template #trigger="{ toggleDropdown }">
      <SquareIconButton
        size="small"
        variant="primary-inverted"
        class="tw-p-3 tw-border-2 tw-rounded-xl"
        @click="toggleDropdown"
      >
        <svg-vue
          class="tw-w-6 tw-flex-shrink-0"
          icon="icons/menu-burger"
        />
      </SquareIconButton>
    </template>

    <template #content>
      <DropdownRow
        as="a"
        href="/actions/add"
      >
        <svg-vue
          class="tw-text-grey tw-w-6 tw-flex-shrink-0"
          icon="icons/plus-border"
        />
        <span>Add Custom Action</span>
      </DropdownRow>

      <DropdownRow
        as="a"
        href="/actions/hidden"
      >
        <svg-vue
          class="tw-text-grey tw-w-6 tw-flex-shrink-0"
          icon="icons/eye-hidden"
        />
        <span>View Hidden</span>
      </DropdownRow>

      <DropdownRow
        @click="exportLiveActionsCSV"
      >
        <svg-vue
          class="tw-text-grey tw-w-6 tw-flex-shrink-0"
          icon="icons/export"
        />
        <span>Export Live CSV</span>
      </DropdownRow>
    </template>
  </BaseDropdown>
</template>
